'use client';

import React from 'react';
import Image from '@src/components/atoms/safe-image';
import { usePathname } from 'next/navigation';
import Link from 'next/link';

// Assets
import Century21 from '@public/png/century-21-black-1.png';
import IBeranda from '@public/svg/i-beranda2';
import IProperti from '@public/svg/i-properti2';

// Hooks
import useRedirect from '@src/hooks/useRedirect';

const TABS = [
  {
    label: 'Beranda',
    pathname: '/marketing/:id',
    icon: <IBeranda />,
  },
  {
    label: 'Properti',
    pathname: '/marketing/:id/list-listing',
    icon: <IProperti />,
  },
];

const Tab = ({
  label,
  pathname,
  currentPath,
  icon,
  id,
  username,
  handleScrollToListProperty,
  handleScrollToProfile,
}) => {
  const isSelected = pathname === `${currentPath}`;

  const selectedClass = isSelected
    ? 'font-satoshi-bold text-[#252526] bg-[#F5F5F5] rounded-[32px] px-[12px] h-[32px]'
    : 'font-satoshi-bold text-[#252526] rounded-[32px] px-[12px] h-[32px]';

  const isBerandaTab = currentPath.includes(`marketing/${username}`) && !currentPath.includes('detail-listing');
  const isDetailListingPage = currentPath.includes('detail-listing');

  if (isBerandaTab && label === 'Beranda') {
    return (
      <button
        onClick={handleScrollToProfile}
        className={`cursor-pointer text-[14px] flex gap-1 items-center ${selectedClass}`}
      >
        {icon && icon} {label}
      </button>
    );
  }

  if (isBerandaTab && label === 'Properti') {
    return (
      <button
        onClick={handleScrollToListProperty}
        className={`cursor-pointer text-[14px] flex gap-1 items-center ${selectedClass}`}
      >
        {icon && icon} {label}
      </button>
    );
  }

  if (isDetailListingPage && label === 'Properti') {
    return (
      <Link
        href={`/marketing/${username}#list-property`}
        className={`cursor-pointer text-[14px] flex gap-1 items-center ${selectedClass}`}
      >
        {icon && icon} {label}
      </Link>
    );
  }

  return (
    <Link
      href={pathname.replace(':id', username)}
      className={`cursor-pointer text-[14px] flex gap-1 items-center ${selectedClass}`}
    >
      {icon && icon} {label}
    </Link>
  );
};

const Navbar = ({
  className,
  handleScrollToListProperty,
  handleScrollToProfile,
  onlineProfile, id
}) => {
  const redirect = useRedirect();
  const currentPath = usePathname();

  const username = onlineProfile?.data?.data?.username || 'century21hq2';
  const companyName = onlineProfile?.data?.data?.office_name || 'Century 21';

  const handleToHomepage = () => {
    redirect(`/marketing/${username}`);
  };

  return (
    <div className="sticky top-0 z-50">
      <div
        className={`section-container relative bg-[#FAFAFA] border-b-[0.5px] border-solid border-[#E6E7E8] ${className} dd2-xl:hidden`}
      >
        <div
          className="py-[16px] w-full flex justify-between max-w-[1344px] 
       dd2-2xl:px-[24px] dd2-2xl:max-w-[unset]
       dd2-xl:px-6"
        >
          <div
            className="cursor-pointer flex flex-col"
            onClick={handleToHomepage}
          >
            <Image
              src={Century21}
              alt="CENTURY 21 Indonesia"
              width="auto"
              height="auto"
              className="cursor-pointer object-contain w-[137px] h-[32px]"
            />
            <span className="text-[12px] font-satoshi-medium text-[#252526]">
              {companyName}
            </span>
          </div>
          <div className="flex items-center gap-4">
            {TABS.map((t, i) => (
              <Tab
                key={`century-21-tabs-${i}`}
                {...t}
                currentPath={currentPath}
                pathname={t.pathname.replace(':id', username)}
                icon={t.icon}
                id={id}
                username={username}
                handleScrollToListProperty={handleScrollToListProperty}
                handleScrollToProfile={handleScrollToProfile}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
